export default __webpack_public_path__ + "static/media/icon_car_parked.f96971b1.svg";